/* eslint-disable */
function isAndroid() {
  const ua = window.navigator.userAgent.toLocaleLowerCase();
  return /Android|Adr/i.test(ua);
}
const uaStr = window.navigator.userAgent.toLocaleLowerCase();
// 处理UA字符串判断平台 miniProgram 明康汇小程序  MKH-APP  明康汇APP
function getplantForm() {
  if (uaStr.indexOf('miniprogram') !== -1) {
    return 'miniProgram';
  } else {
    if (uaStr.indexOf('mkh-app') !== -1) {
      return 'MKH-APP';
    } else {
      return false;
    }
  }
}
function setupWebViewJavascriptBridge(callback) {
  if(getplantForm()==='MKH-APP'){
    if (window.WebViewJavascriptBridge) {
      return callback(WebViewJavascriptBridge);
    } else {
      if (isAndroid()) {
        document.addEventListener(
          'WebViewJavascriptBridgeReady',
          () => {
            window.WebViewJavascriptBridge.init();
            callback(window.WebViewJavascriptBridge);
          },
          false
        );
      } else {
        if (window.WVJBCallbacks) {
          return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function() {
          document.documentElement.removeChild(WVJBIframe);
        }, 0);
      }
    }
  }
}

//初始化
setupWebViewJavascriptBridge(function (bridge) {
  try {
      bridge.init(function (message, callback) {
          callback(null);
      })
  } catch (e) { }
});

export default {
  //js调APP方法 （参数分别为:app提供的方法名  传给app的数据  回调）
  callhandler (method, params, callback) {
      setupWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler(method, params, callback)
      })
  },

  // APP调js方法 （参数分别为:js提供的方法名  回调）
  registerHandler(method, callback) {
      setupWebViewJavascriptBridge((bridge) => {
          bridge.registerHandler(method, (data, responseCallback) => {
              callback(data, responseCallback)
          })
      })
  }
}


// WEBPACK FOOTER //
// ./src/utils/webViewJsBridge.js